<template>
  <!-- HOME : https://www.npmjs.com/package/vue-cleave-component -->
  <!-- 옵션 : https://github.com/nosir/cleave.js/blob/master/doc/options.md -->
  <cleave

    v-bind="{
      ...$attrs,
      options,
      placeholder: '____-__-__',
      raw: 'masked-value' in $attrs == false
    }"
    v-on="$listeners"


    class="imd-input-mask"
    :class="{
      'right' : 'right' in $attrs
    }"

  >
  </cleave>

</template>

<style>
.imd-input-mask.right { text-align: right; }
</style>


<script>
import Cleave from 'vue-cleave-component';
export default {
  inheritAttrs: false,
  components: { Cleave },
  props : {
    delimiter: {
        type: String,
        default: "-"
    },
  },
  data () {
    return {
      // 옵션 문서 :  https://github.com/nosir/cleave.js/blob/master/doc/options.md
      options: {
        date: true,
        datePattern: ['Y', 'm', 'd'],
        delimiter: this.delimiter,
        // delimiterLazyShow: false,
        numericOnly: true,
      }
    }
  }
}
</script>

